import { BaseActions } from '@/models/Common/Actions/BaseActions';
import { execAction } from '@/models/Common/Actions/handler';
import { ResponseEither } from '@/models/Common/ResponseEither';
import debug from 'debug';
import { IFeJourneyMemberLiveBroadcastTokenPayload } from '@/models/FeJourney/interfaces/IFeJourneyMemberLiveBroadcastTokenPayload';
import FeJourneyRequestBuilder from '@/models/FeJourney/FeJourneyRequestBuilder';

const log = debug('sunny:FeJourneyActions');

export default class FeJourneyActions extends BaseActions<FeJourneyRequestBuilder> {
  /**
   * 라이브방송 회원 연동
   *
   * @see https://fe-journey-api.dev.yanolja.in/swagger-ui/index.html#/NOL%20%EB%9D%BC%EC%9D%B4%EB%B8%8C
   */
  liveCommerceToken(): Promise<ResponseEither<IFeJourneyMemberLiveBroadcastTokenPayload>> {
    log('Get live commerce token');
    return execAction('get live commerce token', this.requestBuilder.createPostLiveCommerceToken());
  }
}
